module.exports = __webpack_public_path__ + "img/tavern-icon.526b39bb.png";